module.exports = __webpack_public_path__ + "img/leader_cs.a832c2b0.svg";